import { Select, SelectWithAdd } from '@idaho-aeyc/ui-kit';
import styled from 'styled-components';

export const SSelect = styled(Select)``;

export const SSelectWithAdd = styled(SelectWithAdd)``;
